import './style.scss'

import { ERROR, LOADING, READY, useVisualState } from '../../../hooks/useVisualState'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { get, post } from '../../../helpers/request'

import Button from '../../../components/Button/Button'
import FileUploader from '../../../components/FileUploader/FileUploader'
import { Form } from '../../../components/Form/Form'
import Select from '../../../components/Select/Select'
import SelectItem from '../../../components/Select/SelectItem'
import t from '../../../helpers/i18n'
import { uploadFileHelper } from '../../../helpers/upload'
import useObjectState from '../../../hooks/useObjectState'
import { withRouter } from 'react-router-dom'

const Game = ({ game, teams, seasonId, beforeGame }) => {
  const [, setUploading] = useObjectState()
  const formData = useRef()
  const formPending = useRef()
  const [formValid, setFormValid] = useState(false)
  const [_beforeGame, setBeforeGame] = useState(beforeGame)
  const homeTeam = teams[game.home_team_id]
  const awayTeam = teams[game.away_team_id]

  const handleSave = useCallback(
    (target) => {
      uploadFileHelper(formPending.current, { document: 'files' }, setUploading)
        .then((data) => data.document.id)
        .then((document_id) => {
          post('/soccer/seasons/' + seasonId + '/documents/' + game.game_id, {
            document_id
          })
            .then(() => {
              setBeforeGame(document_id)
            })
            .catch((error) => {
              // TODO: better error handling
              console.log(error)
            })
        })
    },
    [game.game_id, seasonId, setUploading]
  )

  return (
    <div className='-game'>
      <div className='-team'>
        <div className='-logo'>
          <img src={homeTeam.logo} alt='' />
        </div>
        <div>{homeTeam.name}</div>
      </div>
      <div className='-team'>
        <div className='-logo'>
          <img src={awayTeam.logo} alt='' />
        </div>
        <div>{awayTeam.name}</div>
      </div>
      <div>
        <Form
          data={formData}
          pending={formPending}
          onValidityChange={setFormValid}
        >
          <FileUploader
            name='document'
            label={t('labels.File')}
            filename='Previa del partido'
            source={
              _beforeGame &&
              process.env.REACT_APP_IMAGE_BASE_URL +
                '/files/' +
                _beforeGame +
                '?download'
            }
            required
          />
        </Form>
      </div>
      <div className='-buttons'>
        {formValid && (
          <Button
            onClick={(event) => handleSave(event.currentTarget)}
            label={t('buttons.Save')}
          />
        )}
      </div>
    </div>
  )
}

const GameList = withRouter(({ seasonId, journey, teams, beforeGames }) => {
  return (
    <div className='hack-before-game'>
      <h2>{journey.name}</h2>
      {journey.games.map((game) => (
        <Game
          key={game.game_id}
          game={game}
          teams={teams}
          seasonId={seasonId}
          beforeGame={beforeGames[game.game_id]}
        />
      ))}
    </div>
  )
})

const OldBeforeGamesView = () => {
  const [[beforeGamesState, beforeGames], setBeforeGames] = useVisualState()
  const [[seasonsState, seasons], setSeasons] = useVisualState()
  const [seasonId, setSeasonId] = useState()

  const handleChange = useCallback((season_id) => setSeasonId(season_id), [])

  useEffect(() => {
    setSeasons(LOADING)
    get('/soccer/seasons')
      .then((response) => setSeasons(READY, response))
      .catch((error) => setSeasons(ERROR, error))
  }, [setSeasons])

  useEffect(() => {
    if (seasonId) {
      setBeforeGames(LOADING)
      get('/soccer/seasons/' + seasonId + '/documents')
        .then((response) => setBeforeGames(READY, response))
        .catch((error) => setBeforeGames(ERROR, error))
    }
  }, [seasonId, setBeforeGames])

  return (
    <div>
      {seasonsState === READY && (
        <div>
          <Select onChange={handleChange}>
            {Object.keys(seasons).map((season_id) => (
              <SelectItem key={season_id} value={season_id}>
                {seasons[season_id]}
              </SelectItem>
            ))}
          </Select>
        </div>
      )}
      {beforeGamesState === READY &&
        Object.keys(beforeGames.journeys).map((journey_id) => {
          const journey = beforeGames.journeys[journey_id]
          return (
            <GameList
              key={journey_id}
              seasonId={seasonId}
              journey_id={journey_id}
              journey={journey}
              teams={beforeGames.teams}
              beforeGames={beforeGames.documents}
            />
          )
        })}
      {beforeGamesState === ERROR && <div>Error: {beforeGames.code}</div>}
    </div>
  )
}

export default withRouter(OldBeforeGamesView)
